/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ScoreTiss_28ListAliases {
  ADD_SCORE_TISS_28_CUSTOM_DYNAMIC_BUTTON = 'add-score-tiss-28-custom-dynamic-button',
  CONTEXTUAL_BAR = 'contextual-bar',
  DECK_SCORE_TISS_28 = 'deck-score-tiss-28',
  FETCH_SCORE_TISS_28_LIST = 'fetch-score-tiss-28-list',
  FILTERED_LIST_SCORE_TISS_28 = 'filtered-list-score-tiss-28',
  GLOBAL_ACTIONS_0 = 'global-actions-0',
  LAYOUT_SCORE_TISS_28_LIST = 'layout-score-tiss-28-list',
  LEGENDES_SCORE_TISS_28 = 'legendes-score-tiss-28',
  PANEL_GLOBAL_ACTIONS = 'panel-global-actions',
  SCORES_AND_INDEXES_CARD_TISS_28 = 'scores-and-indexes-card-tiss-28',
}
export { ScoreTiss_28ListAliases };
